import React from "react";
import { FiSearch, FiX } from "react-icons/fi";

const FileSearchBar = ({
    value,
    onChange,
    placeholder = "Search files..."
}) => {
    return (
        <div className="relative w-full sm:w-72">
            <FiSearch
                className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                size={13}
            />

            <input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                className="
                    w-full pl-8 pr-8 py-2 text-sm
                    border border-gray-200 rounded-lg
                    focus:outline-none focus:ring-2
                    focus:ring-zinc-700 focus:border-transparent
                    bg-gray-50 placeholder-gray-400
                "
            />

            {value && (
                <button
                    type="button"
                    onClick={() => onChange("")}
                    className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                    <FiX size={12} />
                </button>
            )}
        </div>
    );
};

export default FileSearchBar;